import React, { Component } from "react";
import { Grid } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer className="footer navbar-fixed-bottom">
        <Grid fluid>
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            تمام حقوق برای 
            <a href="http://www.meandme.ir">meandme</a>
            محفوظ است
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;
